import { createSelector } from "reselect";

import BoundaryType from "@mapmycustomers/shared/enum/BoundaryType";

import {
  doesOrganizationSupportDemographicData,
  doesOrganizationSupportTerritories,
} from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

export const boundariesState = (state: RootState) => state.mapLayers.boundaries;

export const getDemographicMetadata = createSelector(boundariesState, ({ metadata }) => metadata);

export const getBoundaryType = createSelector(
  doesOrganizationSupportTerritories,
  boundariesState,
  (territoriesEnabled, { type }) => (territoriesEnabled ? type : BoundaryType.GEOGRAPHY)
);

export const getHighlightedTerritoryId = createSelector(
  boundariesState,
  ({ highlightedTerritoryId }) => highlightedTerritoryId
);

export const areBoundariesVisible = createSelector(boundariesState, ({ visible }) => visible);

export const getDemographicData = createSelector(
  boundariesState,
  ({ demographicData }) => demographicData
);

export const shouldVisualizeDemography = createSelector(
  doesOrganizationSupportDemographicData,
  boundariesState,
  (demographicDataEnabled, { type, visible }) =>
    visible && type === BoundaryType.GEOGRAPHY && demographicDataEnabled
);

export const getDemographyDataCountryCode = createSelector(
  boundariesState,
  ({ demographyDataCountryCode }) => demographyDataCountryCode
);

export const isDemographicDataLoading = createSelector(
  boundariesState,
  ({ demographicDataLoading }) => demographicDataLoading
);

export const getBoundaryViewStates = createSelector(
  boundariesState,
  ({ boundaryViewStates }) => boundaryViewStates
);

export const getBoundaryStats = createSelector(
  boundariesState,
  ({ boundaryStats }) => boundaryStats
);

export const getCountryRegions = createSelector(
  boundariesState,
  ({ countryRegions }) => countryRegions
);
